export interface OptionsType {
  label: string;
  value: number | string;
}
export const getCommonInfoDataConvert = (data: any) => {
  let convertedData = [] as OptionsType[];
  data &&
    data.forEach((item: any) => {
      let selectOptions = {} as OptionsType;
      selectOptions.label = item.positionName;
      selectOptions.value = item.positionId;

      convertedData.push(selectOptions);
    });

  return convertedData?.sort((a, b) =>
    String(a.label).localeCompare(String(b.label)),
  );
};
